import React from 'react';
import { useTheme } from '../../context/shared/ThemeContext'
import ModelSelector from './ModelSelector';
import { PlusIcon } from '@heroicons/react/24/outline';

interface ChatHeaderProps {
  onModelChange: (model: 'Claude' | 'GPT') => void;
  selectedModel: 'Claude' | 'GPT';
  onNewChat: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
  onModelChange,
  selectedModel,
  onNewChat,
}) => {
  const { themeClasses } = useTheme();

  return (
    <div className={`sticky top-16 z-10 ${themeClasses.mainBg} ${themeClasses.primaryText} border-b ${themeClasses.border} p-4 shadow-sm`}>
      <div className="max-w-5xl mx-auto flex items-center">
        {/* Left section: Model selector */}
        <div className="flex-shrink-0">
          <ModelSelector
            selectedModel={selectedModel}
            onModelSelect={onModelChange}
          />
        </div>
        
        {/* Middle section: Empty for now */}
        <div className="flex-grow flex justify-center items-center gap-4">
        </div>

        {/* Right section: New chat button */}
        <div className="flex-shrink-0 flex items-center gap-4">
          <button
            onClick={onNewChat}
            className={`${themeClasses.buttonPrimary} flex items-center gap-2`}
          >
            <PlusIcon className="w-5 h-5" />
            <span>New Chat</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader; 